import React, { useLayoutEffect, useRef } from "react"
import MenuOpen from "../../assets/menuOpen.inline.svg"
import MenuClosed from "../../assets/menuClosed.inline.svg"
import styled from "styled-components"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Logo from "../../assets/logo.inline.svg"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const Holder = styled.header`
  z-index: 1;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  button {
    margin: 0;
    border: none;
    width: auto;
    height: 1.5rem;
    padding: 0;
    background-color: transparent;
    svg {
      width: auto;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      display: block;
    }
  }
`

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

const CustomContainer = styled.div`
  width: 100%;
  max-width: ${(props) => props.theme.typography.maxScreen}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
  margin: 0 auto;
  @media (${(props) => props.theme.breakpoints.sm}) {
    padding: 1rem 1.5rem 0 1.5rem;
  }
  @media (${(props) => props.theme.breakpoints.md}) {
    padding: 1rem 3rem 0 3rem;
  }
  @media (${(props) => props.theme.breakpoints.xl}) {
    padding: 1rem 0 0 0;
  }
  @media (${(props) => props.theme.breakpoints.xxl}) {
    max-width: none;
    padding: 1rem 1rem 0 1rem;
  }
`

const LogoHolder = styled.div`
  a {
    margin: 0;

    svg {
      height: 1.5rem;
      width: auto;
      display: block;
    }
  }
`

function Header(props) {
  const el = useRef()

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: el.current,
            start: "+=100",
            end: "+=210",
            toggleActions: "play none none reverse",
          },
        })
        .to("[id^='small-letter']", {
          autoAlpha: 0,
          transformOrigin: "50% 50%",
          duration: 0.05,
          stagger: 0.01,
        })
        .to("#w-large", {
          xPercent: -170,
          duration: 0.05,
        })
    }, el)
    return () => ctx.revert()
  }, [])

  return (
    <Holder ref={el}>
      <Inner className="inner">
        <CustomContainer>
          <LogoHolder>
            <Link to="/">
              <Logo />
            </Link>
          </LogoHolder>
          <button onClick={() => props.clickHandler()} role="menu button">
            {props.showNav && <MenuOpen />}
            {!props.showNav && <MenuClosed />}
          </button>
        </CustomContainer>
      </Inner>
    </Holder>
  )
}

Header.propTypes = {
  clickHandler: PropTypes.func,
  showNav: PropTypes.bool.isRequired,
}

export default Header
